module.exports = __webpack_public_path__ + "img/app_slide_slow.c78d0ec9.png";